// extracted by mini-css-extract-plugin
export default {"email":"InsightsExportData_email__ml1JP","checkbox":"InsightsExportData_checkbox__jApyG"};